export var RADIO_CLASS_PREFIX = 'Radio';
export var radioIdPrefix = 'radio-id-';
export var radioRoot = 'RadioRoot';